import React from 'react'

const ClickableImg = (props) => {
  return (
    <img src={props.src} onClick={props.onClikc} />
  )
}

export default ClickableImg